import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { equals, pathOr } from 'ramda';
import { reportException } from './exceptionReporting';

interface Props {
  error?: any;
  info?: any
}


const TheApplicationIsOnFire: React.FC<Props> = (props: Props) => {
  const { error, info } = props;


  useEffect(() => {
    //This will trap the oh snap error via sentry
    reportException(`<--------Oh-Snap-Error-Occured--------> ${error}`, info)
  }, [])


  if (error && equals('ChunkLoadError', pathOr('', ['name'], error))) {
    // Reload the window when there's a ChunkLoadError
    window.location.reload();
    return null;
  }

  return (
    <Dialog open>
      <DialogTitle>Oh snap!</DialogTitle>
      <DialogContent>
        Sorry, we’ve run into technical difficulties.
        <div style={{ textAlign: "center" }}>{<ReloadLink />}</div>
      </DialogContent>
    </Dialog>
  );
}

const ReloadLink = () => (
  <a
    onClick={() => {
      location.reload();
    }}
  >
    Go back
  </a>
);

export default TheApplicationIsOnFire;
